<script setup>
// import { useFutureStore } from '~/store/future'
import { usePanelStore } from '~/store/panel'
import MarginMod from './panel/MarginMod.vue'
// import MarginModGrants from './panel/MarginModGrants.vue'
import Types from './panel/Types.vue'
import Board from './panel/Board.vue'
import SideTab from './SideTab.vue'
import AssetPannel from './panel/Info.vue'

const panel = usePanelStore()
// const future = useFutureStore()

const { t } = useI18n()
const sideTabs = computed(() => [
  {
    label: t('开仓'),
    value: 1,
    class: 'bg-buy text-textWhiteStatic',
  },
  {
    label: t('平仓'),
    value: 2,
    class: 'bg-sell text-textWhiteStatic',
  },
])
</script>

<template>
  <div class="w-[300px] bg-fillPagePrimary rounded flex flex-col">
    <ClientOnly>
      <MarginMod />
      <!-- <MarginModGrants v-else /> -->
      <div class="px-3 space-y-4">
        <SideTab v-model="panel.pe" :list="sideTabs" />
        <Types class="!mt-2.5" />
        <Board />
      </div>
      <AssetPannel class="flex-1" />
    </ClientOnly>
  </div>
</template>
